import { Box } from '@chakra-ui/react';
import React from 'react';
import AssessmentItemCard from './AssessmentItemCard';

const AssessmentBlockItems = ({ blockItems, assessmentType }: any) => {
	return (
		<Box display={'flex'} flexWrap="wrap" gap="16px" pb="100px">
			{blockItems
				? // @ts-ignore
				  blockItems?.map(item => {
						if (item?.assessment?.isBadge) return null;
						if (assessmentType !== item?.assessment?.meta?.type?.toLowerCase()) return null;
						console.log('item:', item);
						return (
							<AssessmentItemCard
								userAssessment={item?.userAssessment}
								blockItemId={item._id}
								meta={item?.assessment?.meta}
								assessmentType={assessmentType}
								key={item?._id}
							/>
						);
				  })
				: null}
		</Box>
	);
};

export default AssessmentBlockItems;
